import { FileProcessingStatus } from '../domain/enums';
import { ProviderSummary } from '../domain/types';
import { ProviderHealth } from '../types';

/** A provider with no file for this long is considered inactive. */
export const INACTIVE_AFTER_DAYS = 90;

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Health of one provider for the overview.
 *
 * `failing` means the latest file FAILED in the pipeline and wins over
 * age: a failure stays visible until a newer file lands. REJECTED is not
 * failing — the gatekeeper rejects when no configuration matches, which is
 * a setup problem or noise, so it is shown as a count instead.
 */
export const getProviderHealth = (
  summary: ProviderSummary,
  now: Date = new Date(),
): ProviderHealth => {
  const latest = summary.latestIngestion;

  if (latest === null) {
    return 'inactive';
  }

  if (latest.status === FileProcessingStatus.Failed) {
    return 'failing';
  }

  const ageMs = now.getTime() - new Date(latest.createdAt).getTime();

  if (ageMs > INACTIVE_AFTER_DAYS * DAY_MS) {
    return 'inactive';
  }

  return 'current';
};
